import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './App.css'
import Routes from './Routes'
import ChatWidget from './components/ChatWidget'

class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			facebookSession: null,
			sessionEmail: null,
			adAccounts: null,
			activeAccount: null,
			report: null,
			reportLoadTime: '',
			qualified: false,
			displayInviteModal: false,
			pageHistory: {},
			adMonitorRequests: {},
			trafficSource: props.trafficSource,
			paidTrafficSource: props.paidTrafficSource
		}
	}

	shouldTrackPage = (page) => {
		let { pageHistory } = this.state
		if(!pageHistory[page]) {
			pageHistory[page] = 0
		}
		pageHistory[page] += 1
		return pageHistory[page] !== 2 || /\/report\/act_/.test(page) // track multiple loads of the report
	}

	isAuthenticated = () => {
		return this.state.sessionEmail && this.state.facebookSession
	}

	//
	// These functions are used for the `/` route
	//
	userEmailSet = sessionEmail => {
		this.setState({ sessionEmail })
	}

	facebookSessionValid = () => {
		if(!this.state.facebookSession) { return false }
		const curTime = Math.round(+ new Date() / 1000)
		if(curTime >= this.state.facebookSession.expiresAt) { return false }
		return true
	}

	//
	// These functions are used for the `/login` route
	//
	userFacebookSessionSet = (facebookSession, sessionEmail) => {
		if(facebookSession.accessToken) {
			facebookSession.expiresAt = Math.round(+ new Date() / 1000) + facebookSession.expiresIn - 60 // Give some buffer
			this.setState({facebookSession, sessionEmail})
		}
	}

	adMonitorRequested = accountId => {
		let newAcct = {}
		newAcct[accountId] = 1
		const adMonitorRequests = Object.assign(this.state.adMonitorRequests, newAcct)
		this.setState({adMonitorRequests})
	}

	//
	// These functions are used for the `/accounts` route
	//
	adAccountsFetched = (adAccounts) => {
		this.setState({adAccounts})
	}

	facebookAdAccountSelected = (account) => {
		if(this.state.report && this.state.activeAccount && account.id === this.state.activeAccount.id) {
			// Just redisplay the same report
			this.setState({activeAccount: account})
		} else {
			this.setState({activeAccount: account, report: null})
		}
	}

	exitReport = () => {
		this.setState({ activeAccount: null, report: null, reportLoadTime: '' })
	}

	reportLoaded = (report, reportLoadTime) => {
		if(window.mixpanel) {
			window.mixpanel.track('[AdScore] - Report Loaded', {
				score: report.score,
				spend_365d: report.summary.oneYearSpend,
				spend_30d: report.summary.spend30d
			})
		}
		this.setState({report, reportLoadTime})
	}

	renderChatWidget = () => {
		if(/\/getyourscore/.test(window.location.hash)) {
			return (
				<ChatWidget />
			)
		} else {
			return (<i></i>)
		}
	}

	render() {
		let { sessionEmail, facebookSession, adAccounts, activeAccount, adMonitorRequests, report, reportLoadTime, trafficSource, paidTrafficSource } = this.state
		const childProps = {
			sessionEmail: sessionEmail,
			facebookSession: facebookSession,
			adAccounts: adAccounts,
			activeAccount: activeAccount,
			userEmailSubmitted: this.userEmailSet,
			facebookSessionSet: this.userFacebookSessionSet,
			facebookAdAccountsSet: this.adAccountsFetched,
			facebookAdAccountSelected: this.facebookAdAccountSelected,
			exitReport: this.exitReport,
			facebookSessionValid: this.facebookSessionValid,
			report,
			reportLoadTime,
			reportLoaded: this.reportLoaded,
			adMonitorRequests,
			adMonitorRequested: this.adMonitorRequested,
			trafficSource,
			paidTrafficSource
		}
		return (
			<div className="App">
				{/* Place any globally visible content here */}
				<Routes childProps={childProps} shouldTrackPage={this.shouldTrackPage} />
				{this.renderChatWidget()}
			</div>
		)
	}
}

App.propTypes = {
	trafficSource: PropTypes.string,
	paidTrafficSource: PropTypes.string
}

export default App



// WEBPACK FOOTER //
// ./src/App.js